var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"recaptcha-text tw-text-xs tw-text-grey-700 tw-mt-1",domProps:{"innerHTML":_vm._s(_vm.$t('recaptcha_text'))}})}
var staticRenderFns = []

export { render, staticRenderFns }